var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,0H4C1.789,0,0,1.789,0,4v40c0,2.211,1.789,4,4,4h24v10h-8c-2.209,0-4,1.791-4,4v1c0,0.553,0.447,1,1,1 h30c0.553,0,1-0.447,1-1v-1c0-2.209-1.791-4-4-4h-8V48h24c2.211,0,4-1.789,4-4V4C64,1.789,62.211,0,60,0z M44,60 c1.104,0,2,0.896,2,2H18c0-1.104,0.896-2,2-2H44z M34,58h-4V48h4V58z M62,44c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2v-4h60V44 z M62,38H2V4c0-1.104,0.896-2,2-2h56c1.104,0,2,0.896,2,2V38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M2,40v4c0,1.104,0.896,2,2,2h56c1.104,0,2-0.896,2-2v-4H2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    fill: "#506C7F",
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M44,60H20c-1.104,0-2,0.896-2,2h28C46,60.896,45.104,60,44,60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M2,4v34h60V4c0-1.104-0.896-2-2-2H4C2.896,2,2,2.896,2,4z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#394240",
    cx: 32,
    cy: 43,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    opacity: 0.3,
    width: 4,
    height: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.8973cfc1bc54e7434664ddf7a5e33d90.svg";
export { ForwardRef as ReactComponent };